import React from 'react';

// Partner API documentation, rendered inside the app so the public-facing
// entry point stays on the frontend domain. The Swagger UI itself is served by
// the backend (/api/docs, a curated partner-routes-only spec) and embedded
// here in an iframe rather than linked, so visitors aren't sent to the raw
// backend URL.
// ?? not ||: '' is the deliberate same-origin build value (see client/src/api.js).
const API_BASE = process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:3000';

const ApiDocsPage = () => (
  <div className="flex flex-col" style={{ height: 'calc(100vh - 180px)' }}>
    <div className="mb-4">
      <h2 className="text-3xl font-bold text-white">Partner API Documentation</h2>
      <p className="text-wp-muted mt-1">
        Integrate your own paywall with WallPass: register content, embed the login widget, and verify unlocks
        server-side.
      </p>
    </div>
    <iframe
      src={`${API_BASE}/api/docs`}
      title="WallPass Partner API Documentation"
      className="flex-grow w-full rounded-lg border border-wp-border bg-white"
    />
  </div>
);

export default ApiDocsPage;
